import type { MessagesStats } from '@pages/event/api/useFetchMessagesStats';
import { SendContentType } from '@pages/event/api/useSendMessages';
import { PreloaderCircular } from '@shared/ui/kit';
import { FC } from 'react';
import type { UnsentErrorChannel } from '../../lib/types';
import { StatisticsContent } from '../statistics-content';
import { UnsentContent } from '../unsent-content';
import styles from './modal-body-content.module.scss';

interface ModalBodyContentProps {
  messagesStats: MessagesStats | null;
  contentType: SendContentType;
  isUnsentView: boolean;
  errorChannel: UnsentErrorChannel | null;
  onViewUnsent: (channel: UnsentErrorChannel) => void;
}

export const ModalBodyContent: FC<ModalBodyContentProps> = ({
  messagesStats,
  contentType,
  isUnsentView,
  errorChannel,
  onViewUnsent,
}) => {
  if (!messagesStats) {
    return (
      <div className={styles.loader}>
        <PreloaderCircular />
      </div>
    );
  }

  if (isUnsentView && errorChannel) {
    return <UnsentContent channel={errorChannel} messagesStats={messagesStats} />;
  }

  return <StatisticsContent messagesStats={messagesStats} contentType={contentType} onViewUnsent={onViewUnsent} />;
};
